// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { ShipmentModel } from "@store/Framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickableProps } from "@insite/mobius/Clickable";
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip from "@insite/mobius/Tooltip";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import Download from "@store/Library/Components/Toolkit/Icons/Download";
import InfoLine from "@store/Library/Components/Toolkit/Icons/Info/InfoLine";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { tableProps } from "@store/Themes/common/props/table";
import constants from "@store/constants";
import { getDocumentsWrapper } from "@store/Framework/Common/Utilities/getDocumentsWrapper";
import { trackFileDownload } from "@store/Framework/GoogleAnalytics/hooks";
import Loading from "@store/Library/Components/Icons/Loading";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { getShippingDocuments } from "@store/Framework/Services/documentService";
import { ShipmentsDataViewContext } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateSearchFields";
import ShipmentHistoryFilterTags from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterTags";
import LinkTo from "@store/Library/Components/LinkTo";
import StatusBadge from "@store/Library/Components/StatusBadge";
import { shipmentStatusColorMap } from "@store/Library/Components/statusColorMaps";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import clone from "lodash/clone";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";

const ResultCount = getWidgetComponent("ShipmentHistory/ShipmentHistoryResultCount");
const Pagination = getWidgetComponent("ShipmentHistory/ShipmentHistoryPagination");

const enum fields {
    showDeliveryDate = "showDeliveryDate",
    showOrderNumber = "showOrderNumber",
    showPONumber = "showPONumber",
    showProductNumber = "showProductNumber",
    showQuantities = "showQuantities",
    showDeliveryTerms = "showDeliveryTerms",
    showDeliveryStatus = "showDeliveryStatus",
    showShipmentDocuments = "showShipmentDocuments",
    statusColors = "statusColors",
}

type sortByField = {
    [key: string]: string[];
};

const sortByFields: sortByField = {
    deliveryDate: ["deliveryDate"],
    greifOrderNumber: ["greifOrderNumber"],
    purchaseOrderNumber: ["purchaseOrderNumber"],
    productNumber: ["productNumber"],
    deliveryTerms: ["deliveryTerms"],
    deliveryStatus: ["deliveryStatus"],
    shipmentNumber: ["shipmentNumber"],
};

interface ShipmentRowsModel extends ShipmentModel {
    isLoading: boolean;
    isDisabled: boolean;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showDeliveryDate]: boolean;
        [fields.showOrderNumber]: boolean;
        [fields.showPONumber]: boolean;
        [fields.showProductNumber]: boolean;
        [fields.showQuantities]: boolean;
        [fields.showDeliveryTerms]: boolean;
        [fields.showDeliveryStatus]: boolean;
        [fields.showShipmentDocuments]: boolean;
        [fields.statusColors]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    showPoNumber: getSettingsCollection(state).orderSettings.showPoNumber,
    parameter: state.greif.pages.shipmentHistory.parameter,
    language: state.context.session.language,
    orderDetailsPage: getPageLinkByPageType(state, "OrderDetailsPage"),
});

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface ShipmentHistoryTableStyles {
    container?: InjectableCss;
    headerClickable?: ClickableProps;
    headerText?: TypographyProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: DataTableProps;
    loadingOverlay?: LoadingOverlayProps;
    tableWrapper?: InjectableCss;
    headingWrapper?: FlexWrapperPresentationProps;
    shipmentNumberHeader?: DataTableHeaderProps;
    shipmentDocumentHeader?: DataTableHeaderProps;
    shipmentNumberCells?: DataTableCellProps;
    shipmentDocumentsCells?: DataTableCellProps;
    shipmentNumberLink?: LinkPresentationProps;
    shipmentTightHeader?: DataTableHeaderProps;
    shipmentTightCells?: DataTableCellProps;
    documentLink?: LinkPresentationProps;
    loadingDocumentLink?: LinkPresentationProps;
    actionIcon?: IconProps;
    statusDetailsModal?: ModalPresentationProps;
    actionWrapper?: InjectableCss;
}

export const shipmentHistoryTableStyles: ShipmentHistoryTableStyles = {
    loadingOverlay: tableProps.loadingOverlay,
    tableWrapper: tableProps.wrapper,
    headingWrapper: tableProps.headingWrapper,
    noResultsText: typographyGetNoResultsAltProps({ spaced: false }), // Store Custom Code
    dataTable: tableProps.dataTable,
    shipmentDocumentHeader: tableProps.tightHeader,
    shipmentDocumentsCells: tableProps.tightCell,
    documentLink: linkGetActionLinkProps(Download),
    loadingDocumentLink: linkGetActionLinkProps(Loading),
    actionIcon: {
        src: InfoLine,
        size: 20,
        css: css`
            width: 1rem;
            height: 1rem;
            aspect-ratio: 1/1;
            use {
                stroke: ${getColor("invert")};
                color: ${getColor("invert")};
            }
        `,
    },
    actionWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(8)};
        `,
    },
};

const styles = shipmentHistoryTableStyles;

const ShipmentHistoryTable = ({
    id,
    fields: {
        showDeliveryDate,
        showOrderNumber,
        showPONumber,
        showProductNumber,
        showQuantities,
        showDeliveryTerms,
        showDeliveryStatus,
        showShipmentDocuments,
        statusColors,
    },
    showPoNumber,
    parameter,
    language,
    orderDetailsPage,
    updateSearchFields,
}: Props) => {
    const baseShipmentsDataView = useContext(ShipmentsDataViewContext);
    const shipmentsDataView = usePersistentDataView(baseShipmentsDataView);
    const toasterContext = useContext(ToasterContext);
    const [shipmentRows, setShipmentRows] = useState<ShipmentRowsModel[]>([]);
    const [, setShipmentDocumentsIsLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const shipmentStatusDetails = siteMessage("ShipmentHistory_ShipmentStatusDescriptions");

    const trackLink = ga.use.trackLink();

    const headerClick = (sortField: string) => {
        const previousSort = parameter.sort ?? "";
        const [previousPrimaryField] = previousSort.split(",");
        const direction = previousPrimaryField === sortField ? " DESC" : "";
        const sort = sortByFields[sortField].map(field => `${field}${direction}`).join(", ");
        updateSearchFields({ sort });
    };

    const sorted = (sortField: string) => {
        let sorted: boolean | string = false;

        if (!parameter.sort) {
            return sorted;
        }
        const [primaryField] = parameter.sort.split(",");
        if (primaryField === sortField) {
            sorted = "ascending";
        } else if (primaryField === `${sortField} DESC`) {
            sorted = "descending";
        }
        return sorted as SortOrderOptions;
    };

    useEffect(() => {
        if (shipmentsDataView?.value) {
            const rows = shipmentsDataView?.value?.map(shipment => {
                return {
                    id: shipment.id,
                    deliveryDate: shipment.deliveryDate
                        ? getLocalizedDateTime({
                              dateTime: new Date(shipment.deliveryDate),
                              language,
                          })
                        : "",
                    deliveryDateDisplay: shipment.deliveryDateDisplay,
                    deliveryEtaString: shipment.deliveryEtaString,
                    deliveryMapUrl: shipment.deliveryMapUrl,
                    deliveryTimeZone: shipment.deliveryTimeZone,
                    greifOrderNumberDisplay: shipment.greifOrderNumberDisplay,
                    greifOrderNumber: shipment.greifOrderNumber,
                    greifOrderLineNumber: shipment.greifOrderLineNumber,
                    greifOrderLineSequence: shipment.greifOrderLineSequence,
                    customerSequence: shipment.customerSequence,
                    purchaseOrderNumber: shipment.purchaseOrderNumber,
                    productNumber: shipment.productNumber,
                    customerProductNumber: shipment.customerProductNumber,
                    productNumberDisplay: shipment.productNumberDisplay,
                    quantityOrdered: shipment.quantityOrdered,
                    quantityShipped: shipment.quantityShipped,
                    quantityDisplay: shipment.quantityDisplay,
                    deliveryTerms: shipment.deliveryTerms,
                    deliveryStatus: shipment.deliveryStatus,
                    deliveryStatusDisplay: shipment.deliveryStatusDisplay,
                    shipmentNumberDisplay: shipment.shipmentNumberDisplay,
                    shipmentNumber: shipment.shipmentNumber,
                    canDownloadShipmentDocument: shipment.canDownloadShipmentDocument,
                    isLoading: false,
                    isDisabled: false,
                    locationDescription: shipment.locationDescription,
                };
            });

            setShipmentRows(rows);
        }
    }, [shipmentsDataView?.value]);

    const isTrueOrUndefined = (value?: boolean) => value === true || value === undefined;

    const setShipments = (id: string, value: Partial<ShipmentRowsModel>) => {
        const clonedShipmentRows = clone(shipmentRows);
        const shipmentRowIndex = clonedShipmentRows.findIndex(x => x.id === id);

        for (const key in value) {
            (clonedShipmentRows as any)[shipmentRowIndex][key as keyof ShipmentRowsModel] =
                value[key as keyof ShipmentRowsModel];
        }

        setShipmentRows(clonedShipmentRows);
    };

    const handleDownloadShippingDocuments = (shipmentNumber: string, id: string) => {
        setShipments(id, { isLoading: true, isDisabled: true });

        getDocumentsWrapper(
            getShippingDocuments,
            { shipmentNumber },
            { stateSetter: setShipmentDocumentsIsLoading, toasterContext },
        )
            .then(() => {
                setShipments(id, { isLoading: false, isDisabled: false });
            })
            .catch(() => {
                setShipments(id, { isLoading: false, isDisabled: false });
            });
        trackFileDownload({ file_category: "Shipping Document" });
    };

    const toggleStatusDetailsModal = () => {
        setModalIsOpen(!modalIsOpen);
    };

    const shipmentStatusDescTitle = translate("Shipment Status Descriptions");

    return (
        <DataViewLoadingOverlay dataView={shipmentsDataView} {...styles.loadingOverlay}>
            <ShipmentHistoryFilterTags />
            {!shipmentsDataView.value?.length ? (
                <StyledWrapper {...styles.noResultsContainer}>
                    <Typography {...styles.noResultsText} data-test-selector="shipmentHistoryTable_noShipmentsFound">
                        {translate("No shipments found")}
                    </Typography>
                </StyledWrapper>
            ) : (
                <StyledWrapper {...styles.container} data-test-selector="shipmentHistoryTable">
                    <FlexWrapper {...styles.headingWrapper}>
                        <ResultCount />
                    </FlexWrapper>
                    <StyledWrapper {...styles.tableWrapper}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead>
                                {isTrueOrUndefined(showDeliveryDate) && (
                                    <DataTableHeader
                                        {...styles.shipmentTightHeader}
                                        title={translate("Delivery Date")}
                                        sorted={sorted("deliveryDate")}
                                        onSortClick={() => headerClick("deliveryDate")}
                                        data-test-selector="tableHeader_deliveryDate"
                                    >
                                        {translate("Delivery Date", "deliveryDate")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showOrderNumber) && (
                                    <DataTableHeader
                                        {...styles.shipmentNumberHeader}
                                        title={translate("Greif Order&nbsp;#")}
                                        sorted={sorted("greifOrderNumber")}
                                        onSortClick={() => headerClick("greifOrderNumber")}
                                        data-test-selector="tableHeader_greifOrderNumber"
                                    >
                                        {translate("Greif Order #", "greifOrderNumber")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showPONumber) && showPoNumber && (
                                    <DataTableHeader
                                        {...styles.shipmentNumberHeader}
                                        title={translate("PO #")}
                                        sorted={sorted("purchaseOrderNumber")}
                                        onSortClick={() => headerClick("purchaseOrderNumber")}
                                        data-test-selector="tableHeader_PONumber"
                                    >
                                        {translate("PO #", "poNumber")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showProductNumber) && (
                                    <DataTableHeader
                                        {...styles.shipmentTightHeader}
                                        title={`${translate("Greif Item #")}/ ${translate("Customer Item #")}`}
                                        sorted={sorted("productNumber")}
                                        onSortClick={() => headerClick("productNumber")}
                                        data-test-selector="tableHeader_productNumber"
                                    >
                                        {translate("Greif Item #")}
                                        <br />/ {translate("Customer Item #")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showQuantities) && (
                                    <DataTableHeader
                                        {...styles.shipmentTightHeader}
                                        title={translate("QTY Shipped / Ordered")}
                                        data-test-selector="tableHeader_quantity"
                                    >
                                        {translate("QTY Shipped / Ordered", "quantityDisplay")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showDeliveryTerms) && (
                                    <DataTableHeader
                                        {...styles.shipmentTightHeader}
                                        title={translate("Delivery Terms")}
                                        sorted={sorted("deliveryTerms")}
                                        onSortClick={() => headerClick("deliveryTerms")}
                                    >
                                        {translate("Delivery Terms", "deliveryTerms")}
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showDeliveryStatus) && (
                                    <DataTableHeader
                                        {...styles.shipmentTightHeader}
                                        sorted={sorted("deliveryStatus")}
                                        onSortClick={() => headerClick("deliveryStatus")}
                                        data-test-selector="tableHeader_deliveryStatus"
                                    >
                                        <StyledWrapper as="span" {...styles.actionWrapper}>
                                            {translate("Shipment Status", "shipmentStatus")}
                                            <Clickable
                                                as="span"
                                                role="button"
                                                onKeyDown={(event: React.KeyboardEvent<HTMLButtonElement>) => {
                                                    if (event.key === "Enter" || event.key === " ") {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        event.currentTarget.click();
                                                    }
                                                }}
                                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                    e.stopPropagation();
                                                    toggleStatusDetailsModal();
                                                }}
                                            >
                                                <IconMemo {...styles.actionIcon} title={shipmentStatusDescTitle} />
                                            </Clickable>
                                        </StyledWrapper>
                                    </DataTableHeader>
                                )}
                                {isTrueOrUndefined(showShipmentDocuments) && (
                                    <DataTableHeader
                                        {...styles.shipmentDocumentHeader}
                                        title={translate("Shipment Documents")}
                                        sorted={sorted("shipmentNumber")}
                                        onSortClick={() => headerClick("shipmentNumber")}
                                    >
                                        {translate("Shipment Documents", "shipmentNumber")}
                                    </DataTableHeader>
                                )}
                            </DataTableHead>
                            <DataTableBody data-test-selector="shipmentHistoryTable_tableBody">
                                {shipmentRows?.map(
                                    ({
                                        id,
                                        deliveryDate,
                                        deliveryDateDisplay,
                                        deliveryMapUrl,
                                        greifOrderNumber,
                                        greifOrderNumberDisplay,
                                        purchaseOrderNumber,
                                        productNumber,
                                        quantityDisplay,
                                        deliveryStatus,
                                        deliveryStatusDisplay,
                                        deliveryTerms,
                                        shipmentNumber,
                                        canDownloadShipmentDocument,
                                        shipmentNumberDisplay,
                                        isLoading,
                                        isDisabled,
                                        customerProductNumber,
                                    }) => (
                                        <DataTableRow key={id}>
                                            {isTrueOrUndefined(showDeliveryDate) && (
                                                <DataTableCell
                                                    {...styles.shipmentTightCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_deliveryDate"
                                                >
                                                    <Typography>{deliveryDateDisplay}</Typography>
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showOrderNumber) && (
                                                <DataTableCell
                                                    {...styles.shipmentNumberCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_orderNumber"
                                                >
                                                    <LinkTo
                                                        {...styles.shipmentNumberLink}
                                                        title={greifOrderNumberDisplay}
                                                        pageLink={orderDetailsPage}
                                                        pageIdSegment={`?orderNumber=${greifOrderNumber}`}
                                                        openInNewTab
                                                    />
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showPONumber) && showPoNumber && (
                                                <DataTableCell
                                                    {...styles.shipmentNumberCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_poNumber"
                                                >
                                                    {purchaseOrderNumber}
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showProductNumber) && (
                                                <DataTableCell
                                                    {...styles.shipmentTightCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_productNumber"
                                                >
                                                    <Typography>{productNumber}</Typography> <br />
                                                    <Typography>
                                                        {customerProductNumber && `/ ${customerProductNumber}`}
                                                    </Typography>
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showQuantities) && (
                                                <DataTableCell
                                                    {...styles.shipmentTightCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_quantityDisplay"
                                                >
                                                    {quantityDisplay}
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showDeliveryTerms) && (
                                                <DataTableCell
                                                    {...styles.shipmentTightCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_deliveryTerms"
                                                >
                                                    {deliveryTerms}
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showDeliveryStatus) && (
                                                <DataTableCell
                                                    {...styles.shipmentTightCells}
                                                    data-test-selector="shipmentHistoryTable_tableCell_deliveryStatus"
                                                >
                                                    {statusColors ? (
                                                        <StatusBadge
                                                            status={deliveryStatus}
                                                            displayText={deliveryStatusDisplay || deliveryStatus || ""}
                                                            colorMap={shipmentStatusColorMap}
                                                        />
                                                    ) : (
                                                        deliveryStatusDisplay || deliveryStatus
                                                    )}
                                                </DataTableCell>
                                            )}
                                            {isTrueOrUndefined(showProductNumber) && (
                                                <DataTableCell {...styles.shipmentDocumentsCells}>
                                                    <Link
                                                        {...(isLoading
                                                            ? styles.loadingDocumentLink
                                                            : styles.documentLink)}
                                                        onClick={() =>
                                                            handleDownloadShippingDocuments(shipmentNumber, id)
                                                        }
                                                        disabled={
                                                            !shipmentNumber ||
                                                            isDisabled ||
                                                            !canDownloadShipmentDocument
                                                        }
                                                    >
                                                        {shipmentNumberDisplay || translate("N/A")}
                                                    </Link>
                                                </DataTableCell>
                                            )}
                                        </DataTableRow>
                                    ),
                                )}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                    <Pagination />
                </StyledWrapper>
            )}
            <Modal
                headline={shipmentStatusDescTitle}
                isOpen={modalIsOpen}
                handleClose={toggleStatusDetailsModal}
                {...styles.statusDetailsModal}
            >
                {shipmentStatusDetails}
            </Modal>
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ShipmentHistoryTable)),
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "Search Results Table",
        allowedContexts: [constants.pageType.shipmentHistory],
        fieldDefinitions: [
            {
                name: fields.showDeliveryDate,
                displayName: "Delivery Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "General",
            },
            {
                name: fields.showOrderNumber,
                displayName: "Order Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showPONumber,
                displayName: "PO Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showProductNumber,
                displayName: "Product Number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showQuantities,
                displayName: "Quantities",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showDeliveryTerms,
                displayName: "Delivery Terms",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showDeliveryStatus,
                displayName: "Delivery Status",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showShipmentDocuments,
                displayName: "Shipment Documents",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.statusColors,
                displayName: "Status Color Coding",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
